import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'semantic-ui-react';
import { VerifiedCallerIdTableHeader } from './VerifiedCallerIdTableHeader';

export const VerifiedCallerIdDataTable = props => {
  if (!props.callerIds || props.callerIds.length === 0) {
    return (
      <React.Fragment>
      <div className="phone-inventory-table-wrapper">
        <Table celled selectable sortable className="vci-table">
          <VerifiedCallerIdTableHeader
            column={props.column}
            direction={props.direction}
            handleSort={props.handleSort}
            header={props.tableHeader}
          />
          <Table.Body>
            <Table.Row>
              <Table.Cell colSpan="6" textAlign="center">
                {props.loading ? 'Loading verified caller IDs...' : 'No verified caller IDs found.'}
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </div>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <div className="phone-inventory-table-wrapper">
        <Table celled selectable sortable className="vci-table">
          <VerifiedCallerIdTableHeader
            column={props.column}
            direction={props.direction}
            handleSort={props.handleSort}
            header={props.tableHeader}
          />
          <Table.Body>{props.callerIdRows}</Table.Body>
        </Table>
      </div>
    </React.Fragment>
  );
};

VerifiedCallerIdDataTable.propTypes = {
  callerIds: PropTypes.array.isRequired,
  tableHeader: PropTypes.array.isRequired,
  callerIdRows: PropTypes.any.isRequired,
  column: PropTypes.string,
  direction: PropTypes.string,
  handleSort: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};
